import {
    ShiftSegmentType,
} from '../../Enums';
import OrgJobPathService from '../OrgJobPath';

class ShiftTemplateSegmentService {
    /**
     * @param {BidProfile.IShiftSegmentTemplate[]} segments
     */
    hasTransfer = (segments) => segments
        .some((s) => s.segmentTypeQualifier === ShiftSegmentType.Transfer);

    /**
     * @param {String} transferString "Business Structure;Work Rule;Cost Center;Labor Category1,2,...,6;"
     * @param {String} fullOrgJobPath To show if business structure is empty
     */
    generateTransferStrings = (transferString, fullOrgJobPath) => {
        if (!transferString) {
            return [];
        }

        const splitTransferString = transferString.split(';');
        splitTransferString[0] = splitTransferString[0] || fullOrgJobPath;
        const laborString = splitTransferString[3] || '';

        if (!laborString) {
            return splitTransferString.filter((s) => !!s);
        }
        const splitLaborString = laborString
            .split(',')
            .filter((s) => !!s);

        return splitTransferString
            .filter((s, i) => !!s && i !== 3)
            .concat(splitLaborString);
    };

    /**
     * @param {String} transferString "Business Structure;Work Rule;Cost Center;Labor Category1,2,...,6;"
     * @param {String} fullOrgJobPath To show if business structure is empty
     */
    generateShortTransferStrings = (transferString, fullOrgJobPath) => {
        if (!transferString) {
            return [];
        }
        const transferStrings = this.generateTransferStrings(transferString, fullOrgJobPath);
        transferStrings[0] = OrgJobPathService.getShortShiftOrgJobPath(transferStrings[0]);
        return transferStrings;
    };
}

export default (new ShiftTemplateSegmentService());
